import React, { useEffect, useState } from 'react';
import { Box, Text } from 'pcln-design-system';
import analytics from '../../analytics/analytics';
import { generateHotelSummary } from '../generateHotelSummary';
export const HotelAISummary = ({
  shouldDisplayGenHotelFeature,
  propertyName,
  isExpressDeal,
  fetchRequestOptions,
  prompts,
  description,
  starRating,
  hotelAmenities,
  petDescription
}) => {
  const [summary, setSummary] = useState('');
  const [hasSummaryError, setHasSummaryError] = useState(false);
  const [isSummaryLoading, setSummaryIsLoading] = useState(false);
  useEffect(() => {
    if (!isExpressDeal && shouldDisplayGenHotelFeature && propertyName && !isSummaryLoading) {
      generateHotelSummary({
        prompts,
        source: 'newHotelListingCard',
        fetchRequestOptions,
        hotelDetail: {
          hotelName: propertyName,
          description,
          starRating,
          hotelFeatures: hotelAmenities === null || hotelAmenities === void 0 ? void 0 : hotelAmenities.map(feature => feature.name),
          petPolicy: petDescription
        },
        setSummaryText: summaryText => setSummary(summaryText),
        setSummaryIsLoading: isloading => {
          setSummaryIsLoading(isloading);
        },
        setHasSummaryError: hasError => setHasSummaryError(hasError)
      }).catch(err => {
        analytics.logError({
          message: 'Error generating hotel summary',
          error: JSON.stringify(err),
          loggedFrom: 'HotelDetailCard'
        });
        setHasSummaryError(true);
        setSummaryIsLoading(false);
      });
    }
  }, [propertyName]);
  const shouldDisplayFeatureSummary = shouldDisplayGenHotelFeature && summary && !hasSummaryError;
  if (!shouldDisplayFeatureSummary) {
    return null;
  }
  return React.createElement(Box, null, React.createElement(Text, {
    fontSize: 0,
    lineHeight: '20px',
    pb: 1,
    pt: 2
  }, summary, isSummaryLoading ? ' ... ' : ''));
};
export const HotelAISummaryMemo = React.memo(HotelAISummary, (prev, next) => {
  return prev.propertyName === next.propertyName;
});
HotelAISummaryMemo.displayName = 'HotelAISummary';